/* eslint-disable no-extra-boolean-cast */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import Filter from 'Components/Common/Filter/Filter';
import PaginationComponent from 'Components/Common/Pagination/Pagination';
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import ECListSaleProductSearch from 'Components/Page/EC/ECListSaleProductSearch';
import Tabs from 'Components/Page/EC/ECListSaleProductTabs';
import { PER_PAGE_EC } from 'Constant';
import { DATE_FORMAT_2 } from 'Constant/Date';
import { ECApis, QuerySaleProductsParams } from 'Datasource/EC';
import useErrorBlob from 'Hooks/useErrorBlob';
import useTitlePage from 'Hooks/useTitlePage';
import { endOfDayToGMT, startOfDayToGMT } from 'Utils/DateTime';
import { exportExcel } from 'Utils/File';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { Cell, useTable, useSortBy } from 'react-table';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons';

import { useAppSelector, useAppDispatch } from 'App/Store';
import { setSelectedIds, clearSelectedIds } from 'App/Features/ECBulkUpdate';
import { SortMethod } from 'Components/Common/Table/table';
import ECListSaleStatus from 'Components/Page/EC/ECListSaleStatus';
import { ROLE_RECORD_MENU } from 'Constant/Roles';
import useMessage from 'Hooks/useMessage';
import dayjs from 'dayjs';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { toast } from 'react-toastify';
import TooltipsWithTruncate from 'Components/Common/Tooltips/TooltipsWithTruncate';
import { renderShopName } from 'Constant/Shop';

const btnGroupOptions = [
  { name: 'タイトルベース一覧', value: 0 },
  { name: 'キャンペーンベース一覧', value: 1 },
];

export default function ECListSaleProducts(): JSX.Element {
  const [indexTabDefault] = useState<number>(0);

  const [saleProducts, setSaleProducts] = useState([]);
  const [saleProductsTotal, setSaleProductsTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const { role } = useAppSelector((state) => state.auth);
  const selectedIds = useAppSelector(
    (state) => (state.ecBulkUpdate as any).selectedIds as number[],
  );
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [dataQuery, setDataQuery] = useState<QuerySaleProductsParams>({});

  const { openErrorBlob } = useErrorBlob();

  const [query, setQuery] = useQueryParams({
    page: NumberParam,
    queryArtist: StringParam,
    queryTitle: StringParam,
    artistId: StringParam,
    titleId: StringParam,
    campaignId: StringParam,
    statusId: StringParam,
    saleIds: StringParam,
    startDate: StringParam,
    endDate: StringParam,
    type: StringParam,
    sort: StringParam,
    order: StringParam,
    artistIds: StringParam,
    titleIds: StringParam,
    campaignIds: StringParam,
  });

  const { setMenuTitle } = useTitlePage();

  const [tabActive, setTabActive] = useState(btnGroupOptions[0].name);

  const [activePage, setActivePage] = useState(query.page ?? 1);
  const [exporting, setExporting] = useState<boolean>(false);

  const { openMessageError } = useMessage();

  const handleChangeTabs = (tab: string) => {
    if (!tab) return;
    setTabActive(tab);
  };

  const isRCCompany = useMemo(() => {
    if (
      role &&
      (role === ROLE_RECORD_MENU.RCCompMaster ||
        role === ROLE_RECORD_MENU.RCCompManager ||
        role === ROLE_RECORD_MENU.RCCompManagerHigh ||
        role === ROLE_RECORD_MENU.RCCompManagerLow)
    ) {
      return true;
    }
    return false;
  }, [role]);

  const isMiimEcOrExternalEc = useMemo(() => {
    if (
      role &&
      (role === ROLE_RECORD_MENU.ECCompMaster ||
        role === ROLE_RECORD_MENU.ECCompManager ||
        role === ROLE_RECORD_MENU.SALEChanelMaster ||
        role === ROLE_RECORD_MENU.SALEChanelManager)
    ) {
      return true;
    }
    return false;
  }, [role]);

  const isEcChannelRole = isMiimEcOrExternalEc;

  const columnsTitle = useMemo(
    () => [
      {
        Header: 'ID',
        className: 'd-flex align-items-center justify-content-center',
        accessor: 'id',
        width: 80,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <span className="text-start">{row.original?.productId}</span>
            </div>
          );
        },
      },
      {
        Header: '販売チャネル',
        className: 'd-flex align-items-center',
        accessor: 'channelName',
        width: 120,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.channelName}</span>
            </div>
          );
        },
      },
      {
        Header: 'ステータス',
        className: 'd-flex align-items-center',
        accessor: 'status',
        width: 140,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start">
                <ECListSaleStatus status={row.original?.status} />
              </span>
            </div>
          );
        },
      },
      {
        Header: '販売用ID',
        className: 'd-flex align-items-center justify-content-center',
        accessor: 'cardCd',
        width: 300,
        Cell: ({ row }: Cell<any>) => {
          return row.original?.cdId === null ? (
            <div className="d-flex align-items-center h-100 p-2 justify-content-center">
              <Link
                to={`/ec/sale-product-detail/${row.original?.ecProductsChannelDetailId}`}
                // to={`/campaigns/${row.original?.id}`}
                // onClick={() => {
                //   dispatch(updateMailList({ mailList: [], isSuccess: false }));
                // }}
                className="d-block text-nowrap"
              >
                <span className="text-start ec-monospace">{row.original?.cardCd}</span>
              </Link>
            </div>
          ) : (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-nowrap">物販商品</span>
            </div>
          );
        },
      },
      {
        Header: '販売店舗',
        className: 'd-flex align-items-center',
        accessor: 'shopName',
        width: 180,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.shopName}</span>
            </div>
          );
        },
      },
      {
        Header: 'キャンペーン商品名称',
        className: 'd-flex align-items-center ec-fixed-col',
        accessor: 'productName',
        width: 269,
        Cell: ({ row }: Cell<any>) => {
          return row.original?.productType === 0 ? (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-nowrap">マスタ</span>
            </div>
          ) : (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.productName}</span>
            </div>
          );
        },
      },
      {
        Header: 'アーティスト',
        className: 'd-flex align-items-center',
        accessor: 'artistName',
        width: 234,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.artistName}</span>
            </div>
          );
        },
      },
      {
        Header: 'タイトル',
        className: 'd-flex align-items-center',
        accessor: 'titleName',
        width: 251,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              {/* <Link
                to={`/title-detail/${row.original?.titleId}`}
                // to={`/campaigns/${row.original?.id}`}
                // onClick={() => {
                //   dispatch(updateMailList({ mailList: [], isSuccess: false }));
                // }}
                className="d-block text-break"
              > */}
              <span className="text-start text-truncate">{row.original?.titleName}</span>
              {/* </Link> */}
            </div>
          );
        },
      },
      {
        Header: 'バリエーション',
        className: 'd-flex align-items-center',
        accessor: 'variationName',
        width: 234,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.variationName}</span>
            </div>
          );
        },
      },
      {
        Header: 'ページ公開期間',
        className: 'd-flex align-items-center',
        accessor: 'publicStartDate',
        width: 320,
        Cell: ({ row }: Cell<any>) => {
          const start = row.original?.publicStartDate
            ? dayjs(row.original?.publicStartDate).format(DATE_FORMAT_2)
            : null;
          const end = row.original?.publicEndDate
            ? dayjs(row.original?.publicEndDate).format(DATE_FORMAT_2)
            : null;
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <span className="text-start ec-monospace text-nowrap">
                {start || end ? `${start ?? ''} ～ ${end ?? ''}` : null}
              </span>
            </div>
          );
        },
      },
      {
        Header: '販売期間',
        className: 'd-flex align-items-center',
        accessor: 'saleStartDate',
        width: 320,
        Cell: ({ row }: Cell<any>) => {
          const start = row.original?.saleStartDate
            ? dayjs(row.original?.saleStartDate).format(DATE_FORMAT_2)
            : null;
          const end = row.original?.saleEndDate
            ? dayjs(row.original?.saleEndDate).format(DATE_FORMAT_2)
            : null;
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <span className="text-start ec-monospace text-nowrap">
                {start || end ? `${start ?? ''} ～ ${end ?? ''}` : null}
              </span>
            </div>
          );
        },
      },
      {
        Header: 'プレビュー',
        className: 'd-flex align-items-center',
        width: 120,
        disableSortBy: true,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <CopyToClipboard
                onCopy={() => {
                  toast('クリップボードにコピーしました。', { type: 'success' });
                }}
                text={`${row.original?.preview}`}
              >
                <div>
                  <svg
                    style={{ marginRight: '5px', cursor: 'pointer' }}
                    xmlns="http://www.w3.org/2000/svg"
                    width={18}
                    height={18}
                    viewBox="0 0 32 32"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M4,8 L4,28 L24,28 L24,8 L4,8 Z M4,6 L24,6 C25.1045695,6 26,6.8954305 26,8 L26,28 C26,29.1045695 25.1045695,30 24,30 L4,30 C2.8954305,30 2,29.1045695 2,28 L2,8 C2,6.8954305 2.8954305,6 4,6 Z"
                      />
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M8,6 L6,6 L6,4 C6,2.8954305 6.8954305,2 8,2 L28,2 C29.1045695,2 30,2.8954305 30,4 L30,24 C30,25.1045695 29.1045695,26 28,26 L26,26 L26,24 L28,24 L28,4 L8,4 L8,6 Z"
                      />
                    </g>
                  </svg>
                </div>
              </CopyToClipboard>
              <a
                href={`${row.original?.preview}`}
                target="_blank"
                rel="noreferrer"
                className="d-block text-break"
              >
                <span className="text-start">preview</span>
              </a>
            </div>
          );
        },
      },
      {
        Header: '本番URL',
        className: 'd-flex align-items-center',
        width: 96,
        disableSortBy: true,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <CopyToClipboard
                onCopy={() => {
                  toast('クリップボードにコピーしました。', { type: 'success' });
                }}
                text={`${row.original?.urlProduction}`}
              >
                <div>
                  <svg
                    style={{ marginRight: '5px', cursor: 'pointer' }}
                    xmlns="http://www.w3.org/2000/svg"
                    width={18}
                    height={18}
                    viewBox="0 0 32 32"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M4,8 L4,28 L24,28 L24,8 L4,8 Z M4,6 L24,6 C25.1045695,6 26,6.8954305 26,8 L26,28 C26,29.1045695 25.1045695,30 24,30 L4,30 C2.8954305,30 2,29.1045695 2,28 L2,8 C2,6.8954305 2.8954305,6 4,6 Z"
                      />
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M8,6 L6,6 L6,4 C6,2.8954305 6.8954305,2 8,2 L28,2 C29.1045695,2 30,2.8954305 30,4 L30,24 C30,25.1045695 29.1045695,26 28,26 L26,26 L26,24 L28,24 L28,4 L8,4 L8,6 Z"
                      />
                    </g>
                  </svg>
                </div>
              </CopyToClipboard>
              <a
                href={`${row.original?.urlProduction}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (!row.original?.isPublic || [0, 1, 5].includes(row.original?.status)) {
                    toast('商品は非公開中です。', { type: 'error' });
                  } else {
                    window.open(`${row.original?.urlProduction}`, '_blank');
                  }
                }}
                className="d-block text-break text-truncate"
              >
                <span className="text-start">URL</span>
              </a>
            </div>
          );
        },
      },
    ],
    [],
  );

  const columnsCampaign = useMemo(
    () => [
      {
        Header: 'ID',
        className: 'd-flex align-items-center justify-content-center',
        accessor: 'id',
        width: 100,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <span className="text-start">{row.original?.productId}</span>
            </div>
          );
        },
      },
      {
        Header: '販売チャネル',
        className: 'd-flex align-items-center',
        accessor: 'channelName',
        width: 234,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.channelName}</span>
            </div>
          );
        },
      },
      {
        Header: 'ステータス',
        className: 'd-flex align-items-center',
        accessor: 'status',
        width: 140,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start">
                <ECListSaleStatus status={row.original?.status} />
              </span>
            </div>
          );
        },
      },
      {
        Header: '販売用ID',
        className: 'd-flex align-items-center justify-content-center',
        accessor: 'cardCd',
        width: 300,
        Cell: ({ row }: Cell<any>) => {
          return row.original?.cdId === null ? (
            <div className="d-flex align-items-center h-100 p-2 justify-content-center">
              <Link
                to={`/ec/sale-product-detail/${row.original?.ecProductsChannelDetailId}`}
                // to={`/campaigns/${row.original?.id}`}
                // onClick={() => {
                //   dispatch(updateMailList({ mailList: [], isSuccess: false }));
                // }}
                className="d-block text-nowrap"
              >
                <span className="text-start ec-monospace">{row.original?.cardCd}</span>
              </Link>
            </div>
          ) : (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-nowrap">物販商品</span>
            </div>
          );
        },
      },
      {
        Header: '販売店舗',
        className: 'd-flex align-items-center',
        accessor: 'shopName',
        width: 180,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.shopName}</span>
            </div>
          );
        },
      },
      {
        Header: 'キャンペーン商品名称',
        className: 'd-flex align-items-center ec-fixed-col',
        accessor: 'productName',
        width: 269,
        Cell: ({ row }: Cell<any>) => {
          return row.original?.productType === 0 ? (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-nowrap">マスタ</span>
            </div>
          ) : (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.productName}</span>
            </div>
          );
        },
      },
      {
        Header: 'キャンペーン',
        className: 'd-flex align-items-center',
        accessor: 'campaignName',
        width: 234,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.campaignName}</span>
            </div>
          );
        },
      },
      {
        Header: 'アーティスト',
        className: 'd-flex align-items-center',
        accessor: 'artistName',
        width: 234,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.artistName}</span>
            </div>
          );
        },
      },
      {
        Header: 'タイトル',
        className: 'd-flex align-items-center',
        accessor: 'titleName',
        width: 251,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              {/* <Link
                to={`/title-detail/${row.original?.titleId}`}
                // to={`/campaigns/${row.original?.id}`}
                // onClick={() => {
                //   dispatch(updateMailList({ mailList: [], isSuccess: false }));
                // }}
                className="d-block text-break"
              > */}
              <span className="text-start text-truncate">{row.original?.titleName}</span>
              {/* </Link> */}
            </div>
          );
        },
      },
      {
        Header: 'バリエーション',
        className: 'd-flex align-items-center',
        accessor: 'variationName',
        width: 234,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center h-100 p-2">
              <span className="text-start text-truncate">{row.original?.variationName}</span>
            </div>
          );
        },
      },
      {
        Header: 'ページ公開期間',
        className: 'd-flex align-items-center',
        accessor: 'publicStartDate',
        width: 320,
        Cell: ({ row }: Cell<any>) => {
          const start = row.original?.publicStartDate
            ? dayjs(row.original?.publicStartDate).format(DATE_FORMAT_2)
            : null;
          const end = row.original?.publicEndDate
            ? dayjs(row.original?.publicEndDate).format(DATE_FORMAT_2)
            : null;
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <span className="text-start ec-monospace text-nowrap">
                {start || end ? `${start ?? ''} ～ ${end ?? ''}` : null}
              </span>
            </div>
          );
        },
      },
      {
        Header: '販売期間',
        className: 'd-flex align-items-center',
        accessor: 'saleStartDate',
        width: 320,
        Cell: ({ row }: Cell<any>) => {
          const start = row.original?.saleStartDate
            ? dayjs(row.original?.saleStartDate).format(DATE_FORMAT_2)
            : null;
          const end = row.original?.saleEndDate
            ? dayjs(row.original?.saleEndDate).format(DATE_FORMAT_2)
            : null;
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <span className="text-start ec-monospace text-nowrap">
                {start || end ? `${start ?? ''} ～ ${end ?? ''}` : null}
              </span>
            </div>
          );
        },
      },
      {
        Header: 'プレビュー',
        className: 'd-flex align-items-center',
        width: 140,
        disableSortBy: true,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <CopyToClipboard
                onCopy={() => {
                  toast('クリップボードにコピーしました。', { type: 'success' });
                }}
                text={`${row.original?.preview}`}
              >
                <div>
                  <svg
                    style={{ marginRight: '5px', cursor: 'pointer' }}
                    xmlns="http://www.w3.org/2000/svg"
                    width={22}
                    height={22}
                    viewBox="0 0 32 32"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M4,8 L4,28 L24,28 L24,8 L4,8 Z M4,6 L24,6 C25.1045695,6 26,6.8954305 26,8 L26,28 C26,29.1045695 25.1045695,30 24,30 L4,30 C2.8954305,30 2,29.1045695 2,28 L2,8 C2,6.8954305 2.8954305,6 4,6 Z"
                      />
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M8,6 L6,6 L6,4 C6,2.8954305 6.8954305,2 8,2 L28,2 C29.1045695,2 30,2.8954305 30,4 L30,24 C30,25.1045695 29.1045695,26 28,26 L26,26 L26,24 L28,24 L28,4 L8,4 L8,6 Z"
                      />
                    </g>
                  </svg>
                </div>
              </CopyToClipboard>
              <a
                href={`${row.original?.preview}`}
                // to={`/campaigns/${row.original?.id}`}
                // onClick={() => {
                //   dispatch(updateMailList({ mailList: [], isSuccess: false }));
                // }}
                target="_blank"
                rel="noreferrer"
                className="d-block text-break"
              >
                <span className="text-start">preview</span>
              </a>
            </div>
          );
        },
      },
      {
        Header: '本番URL',
        className: 'd-flex align-items-center',
        width: 96,
        disableSortBy: true,
        Cell: ({ row }: Cell<any>) => {
          return (
            <div className="d-flex align-items-center justify-content-center h-100 p-2">
              <CopyToClipboard
                onCopy={() => {
                  toast('クリップボードにコピーしました。', { type: 'success' });
                }}
                text={`${row.original?.urlProduction}`}
              >
                <div>
                  <svg
                    style={{ marginRight: '5px', cursor: 'pointer' }}
                    xmlns="http://www.w3.org/2000/svg"
                    width={22}
                    height={22}
                    viewBox="0 0 32 32"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M4,8 L4,28 L24,28 L24,8 L4,8 Z M4,6 L24,6 C25.1045695,6 26,6.8954305 26,8 L26,28 C26,29.1045695 25.1045695,30 24,30 L4,30 C2.8954305,30 2,29.1045695 2,28 L2,8 C2,6.8954305 2.8954305,6 4,6 Z"
                      />
                      <path
                        fill="#005CD9"
                        fillRule="nonzero"
                        d="M8,6 L6,6 L6,4 C6,2.8954305 6.8954305,2 8,2 L28,2 C29.1045695,2 30,2.8954305 30,4 L30,24 C30,25.1045695 29.1045695,26 28,26 L26,26 L26,24 L28,24 L28,4 L8,4 L8,6 Z"
                      />
                    </g>
                  </svg>
                </div>
              </CopyToClipboard>
              <a
                href={`${row.original?.urlProduction}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (!row.original?.isPublic || [0, 1, 5].includes(row.original?.status)) {
                    toast('商品は非公開中です。', { type: 'error' });
                  } else {
                    window.open(`${row.original?.urlProduction}`, '_blank');
                  }
                }}
                className="d-block text-break text-truncate"
              >
                <span className="text-start">URL</span>
              </a>
            </div>
          );
        },
      },
    ],
    [],
  );

  const columnsTitleFiltered = useMemo(
    () =>
      isEcChannelRole
        ? columnsTitle.filter((c: any) => c.accessor !== 'channelName')
        : columnsTitle,
    [columnsTitle, isEcChannelRole],
  );

  const columnsCampaignFiltered = useMemo(
    () =>
      isEcChannelRole
        ? columnsCampaign.filter((c: any) => c.accessor !== 'channelName')
        : columnsCampaign,
    [columnsCampaign, isEcChannelRole],
  );

  const injectCheckboxIntoIdColumn = useCallback(
    (columns: any[]) =>
      columns.map((col) => {
        if (col.accessor !== 'id') return col;
        return {
          ...col,
          Cell: ({ row }: Cell<any>) => {
            const id = row.original?.ecProductsChannelDetailId;
            const checked = selectedIds.includes(id);
            const toggle = () => {
              const newIds = checked
                ? selectedIds.filter((sid) => sid !== id)
                : [...selectedIds, id];
              dispatch(setSelectedIds(newIds));
            };
            return (
              <div
                className="d-flex align-items-center justify-content-center h-100 p-2 gap-2"
                style={{ cursor: 'pointer' }}
                onClick={toggle}
                onKeyDown={(e) => e.key === 'Enter' && toggle()}
                role="button"
                tabIndex={0}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={toggle}
                  onClick={(e) => e.stopPropagation()}
                />
                <span>{row.original?.productId}</span>
              </div>
            );
          },
        };
      }),
    [selectedIds, dispatch],
  );

  const columnsTitleFinal = useMemo(
    () =>
      isEcChannelRole ? injectCheckboxIntoIdColumn(columnsTitleFiltered) : columnsTitleFiltered,
    [injectCheckboxIntoIdColumn, columnsTitleFiltered, isEcChannelRole],
  );

  const columnsCampaignFinal = useMemo(
    () =>
      isEcChannelRole
        ? injectCheckboxIntoIdColumn(columnsCampaignFiltered)
        : columnsCampaignFiltered,
    [injectCheckboxIntoIdColumn, columnsCampaignFiltered, isEcChannelRole],
  );

  const handleGetSaleProducts = async (queries: QuerySaleProductsParams) => {
    try {
      setLoading(true);
      const {
        data: { data },
      } = await ECApis.getSaleProducts(queries);

      setSaleProducts(data.items);
      setSaleProductsTotal(data?.meta?.itemCount);
    } catch (error) {
      openMessageError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      const newDataQuery = { ...dataQuery };

      if (newDataQuery?.page) {
        delete newDataQuery.page;
      }

      if (newDataQuery?.sort) {
        delete newDataQuery.sort;
      }
      if (query?.type === '0' || query?.type === undefined) {
        await exportExcel(
          ECApis.saleProductDownloadExcel({ ...newDataQuery, type: '0' }),
          `EC販売商品リスト_タイトルベース一覧_${dayjs().format('YYYYMMDDHHmmss')}`,
        );
      }
      if (query?.type === '1') {
        await exportExcel(
          ECApis.saleProductDownloadExcel(newDataQuery),
          `EC販売商品リスト_キャンペーンベース一覧_${dayjs().format('YYYYMMDDHHmmss')}`,
        );
      }
    } catch (error) {
      // console.log(error, 'heressss');
      openErrorBlob(error);
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    setMenuTitle('EC販売商品リスト');
    dispatch(clearSelectedIds());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const queries = {
      limit: PER_PAGE_EC,
      page: activePage,
      artistId: query.artistId,
      titleId: query.titleId,
      campaignId: query.campaignId,
      statusId: query.statusId,
      saleIds: query.saleIds,
      startDate: query.startDate ? startOfDayToGMT(query.startDate) : null,
      endDate: query.endDate ? endOfDayToGMT(query.endDate) : null,
      type: query.type,
      sort: query.sort || 'id',
      order: query.order || 'DESC',
      artistIds: query.artistIds,
      titleIds: query.titleIds,
      campaignIds: query.campaignIds,
    };
    setDataQuery(queries);
    handleGetSaleProducts(queries);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activePage,
    query.artistId,
    query.titleId,
    query.campaignId,
    query.statusId,
    query.type,
    query.startDate,
    query.endDate,
    query.saleIds,
    query.sort,
    query.order,
    query.artistIds,
    query.titleIds,
    query.campaignIds,
  ]);

  //* handle sort from server side
  const handleManualSort = useCallback(
    (sortBy: SortMethod[]) => {
      if (sortBy.length > 0) {
        const sortOption = sortBy[0];
        const sortKey = sortOption.id;
        setQuery({ sort: sortKey, order: sortOption.desc ? 'DESC' : 'ASC' });
      } else {
        setQuery({ sort: '', order: '' });
      }
    },
    [setQuery],
  );

  return (
    <>
      <SpinnerComponent isLoading={loading} />
      <Container fluid>
        <Filter filterClass="shadow-sm">
          <div className="mb-3">
            <Tabs
              options={btnGroupOptions}
              tabActive={tabActive}
              onChange={handleChangeTabs}
              indexDefault={indexTabDefault}
            />
          </div>
          <Row className="align-items-end justify-content-end">
            <Col md="10" className="px-0">
              <ECListSaleProductSearch />
            </Col>
            <Col md="2" className="text-end px-0 mt-3">
              <Button
                variant="primary"
                className={`btn-excel w-btn btn-focus-none ms-4 ${exporting ? 'pe-none' : ''}`}
                onClick={handleExportExcel}
              >
                {exporting ? (
                  <Spinner
                    animation="border"
                    variant="light"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  'Excel ダウンロード'
                )}
              </Button>
            </Col>
          </Row>
        </Filter>
        <Row className="mt-3">
          <Col md={12} className="d-flex justify-content-end p-0 px-4">
            <PaginationComponent
              activePage={activePage}
              total={saleProductsTotal}
              perPage={PER_PAGE_EC}
              onClick={(newPage) => setActivePage(newPage)}
            />
          </Col>
        </Row>
        <div className="table-nft-container">
          {isEcChannelRole && (
            <div className="mt-2 px-0">
              <Button
                variant="dark"
                disabled={selectedIds.length === 0}
                onClick={() => history.push('/ec/bulk-update-sale-products')}
              >
                一括変更
              </Button>
            </div>
          )}
          <Row className="mt-3">
            <Col md={12} className="d-flex justify-content-center p-0">
              <ECSaleTable
                heightBody="calc(100vh - 250px)"
                columns={query?.type === '1' ? columnsCampaignFinal : columnsTitleFinal}
                data={saleProducts}
                onSort={handleManualSort}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

function ECSaleTable({
  columns,
  data,
  heightBody,
  onSort,
}: {
  columns: any[];
  data: any[];
  heightBody: string;
  onSort: (sortBy: SortMethod[]) => void;
}) {
  const [query] = useQueryParams({
    sort: StringParam,
    order: withDefault(StringParam, 'DESC', true),
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      manualSortBy: true,
      autoResetSortBy: false,
      initialState: {
        sortBy: query.sort ? [{ id: query.sort, desc: query.order === 'DESC' }] : [],
      },
    },
    useSortBy,
  );

  useEffect(() => {
    onSort(sortBy as SortMethod[]);
  }, [onSort, sortBy]);

  const renderSortIcon = (column: any) => {
    const isDesc = column.isSortedDesc || (query.order === 'DESC' && query.sort === column.id);
    const isAsc =
      (!column.isSortedDesc && column.isSorted) ||
      (query.order === 'ASC' && query.sort === column.id && !column.isSorted);
    return (
      <div className="fs-12 d-flex flex-column ms-1">
        <CaretUpFill className={isAsc ? 'text-primary' : ''} />
        <CaretDownFill className={isDesc ? 'text-primary' : ''} />
      </div>
    );
  };

  if (!data || data.length === 0) {
    return (
      <div className="vh-100-final d-flex align-items-center justify-content-center">
        検索結果がありません。
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto', overflowY: 'auto', height: heightBody }}>
      <table className="ec-table-auto-fit table table-bordered table-radius" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={hgKey} {...hgProps}>
                {headerGroup.headers.map((column: any) => {
                  const { key: colKey, ...colProps } = column.getHeaderProps(
                    column.getSortByToggleProps(),
                  );
                  return (
                    <th key={colKey} {...colProps} className="bg-dark text-white text-center">
                      <div className={`d-flex align-items-center w-100 ${column.className ?? ''}`}>
                        <span className="flex-grow-1">{column.render('Header')}</span>
                        {!column.disableSortBy && renderSortIcon(column)}
                      </div>
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            const { key: rowKey, ...rowProps } = row.getRowProps();
            return (
              <tr key={rowKey} {...rowProps}>
                {row.cells.map((cell: any) => {
                  const { key: cellKey, ...cellProps } = cell.getCellProps();
                  return (
                    <td
                      key={cellKey}
                      {...cellProps}
                      className={`p-0${cell.column.id === 'productName' ? ' ec-fixed-col' : ''}`}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
